// Utility to normalize attachments to a renderable kind so UI can handle
// new/backfilled media types (e.g., story) consistently.
export const resolveAttachmentKind = (item) => {
  if (!item) return null;

  const type = item?.type?.toLowerCase?.();
  const mime = item?.mime_type?.toLowerCase?.();
  const mediaType = item?.media_type?.toLowerCase?.();
  const contentType = item?.content_type?.toLowerCase?.();
  const url = item?.url?.toLowerCase?.() || '';

  if (type === 'download') return 'download';

  const hasVideoFlag = item?.is_video || item?.has_video;
  const videoByMeta =
    hasVideoFlag ||
    type === 'video' ||
    mediaType === 'video' ||
    mediaType?.startsWith?.('video') ||
    mime?.startsWith('video') ||
    contentType?.startsWith?.('video') ||
    type?.includes?.('video') ||
    mediaType?.includes?.('video');
  const videoByExtension = /\.(mp4|mov|mkv|webm|m4v|avi)(\?|$)/i.test(url);
  const videoByStructure = item?.thumbnail_url || item?.duration_ms;
  if (videoByMeta || videoByExtension || videoByStructure) return 'video';

  const imageByMeta =
    type === 'image' ||
    type === 'story' ||
    mediaType === 'image' ||
    mediaType?.startsWith?.('image') ||
    mime?.startsWith('image') ||
    contentType?.startsWith?.('image') ||
    type?.includes?.('image') ||
    mediaType?.includes?.('image');
  const imageByExtension =
    /\.(jpe?g|png|gif|webp|avif|bmp|heic|heif)(\?|$)/i.test(url);
  if (imageByMeta || imageByExtension) return 'image';

  // Default to image so the modal still renders something sensible.
  return 'image';
};
